module.exports = __webpack_public_path__ + "static/media/funcesp-mobile.547daf50.jpg";